import { useFeatureFlag } from './use-feature-flag';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';

export const useEnableHomepageCreateLabel = () => useFeatureFlag(FeatureFlagDeclarations.enableHomepageCreateLabel);
